import { fetchJSON, merge } from 'omni-ui';

const originsByEnv = {
  local: 'https://devplanningtools-api.annalect.com',
  dev: 'https://devplanningtools-api.annalect.com',
  qa: 'https://qaplanningtools-api.annalect.com',
  stg: 'https://stgplanningtools-api.annalect.com',
  prod: 'https://planningtools-api.annalect.com',
};

export default class PlanningToolsAPI {
  static reachChannels = {};

  constructor(env, clientId) {
    this.env = env;
    this.clientId = clientId;
    this.origin = originsByEnv[env];
    this.baseFetchOptions = {
      headers: { ANsid: AN.sso.session.sid, clientid: clientId },
    };

    if (!this.constructor.reachChannels[clientId])
      this.constructor.reachChannels[clientId] = {};
  }

  canCreate() {
    const createRoles = [
      'external client - collaborator',
      'administrator',
      'editor',
    ];
    const project = AN.sso.user.projects.find(
      proj => proj.typeKey === 'an_icp',
    );
    return !!project?.userRoles?.some(role => createRoles.includes(role));
  }

  createAllocationPlan(campaignData, audiences, market) {
    return fetchJSON(
      `${this.origin}/api/v2/plans/allocation`,
      merge(this.baseFetchOptions, {
        method: 'POST',
        body: JSON.stringify({
          name: campaignData.name,
          description: campaignData.description,
          image: campaignData.image_url,
          start_date: campaignData.start_date,
          end_date: campaignData.end_date,
          scenarios: audiences.map(audience => ({
            budget: audience.budget ?? 0,
            primary_currency: campaignData.currency,
            scenario_name: `${audience.name} - ${audience.stageName}`,
            brands: [''],
            markets: [market],
            audiences: {
              [market]: {
                audience_name: audience.name,
                audience_size: Math.round(
                  (audience.populationCount * (audience.percent ?? 100)) / 100,
                ),
                total_population_size: audience.populationCount,
              },
            },
            reach_channel_selections: audience.channels.map(channel => ({
              channel_id: channel.id,
              cpm: { [market]: channel.cpm },
              influence_score: channel.influence_score,
            })),
          })),
        }),
      }),
    );
  }

  async getReachChannels(market) {
    // Only load reach channels once per client / market / session (cached as static field)
    if (!this.constructor.reachChannels[this.clientId][market])
      this.constructor.reachChannels[this.clientId][market] = await fetchJSON(
        `${this.origin}/api/v2/channel/reach?markets=${market}`,
        this.baseFetchOptions,
      );
    return this.constructor.reachChannels[this.clientId][market];
  }
}
